/**
 * Internal dependencies
 */
import I18N from './i18n';
import localizeFactory from './localize';
import translateHookFactory from './use-translate';
import rtlFactory from './rtl';
var i18n = new I18N();
export { I18N };
export default i18n;
export var numberFormat = i18n.numberFormat.bind(i18n);
export var translate = i18n.translate.bind(i18n);
export var configure = i18n.configure.bind(i18n);
export var setLocale = i18n.setLocale.bind(i18n);
export var getLocale = i18n.getLocale.bind(i18n);
export var getLocaleSlug = i18n.getLocaleSlug.bind(i18n);
export var addTranslations = i18n.addTranslations.bind(i18n);
export var reRenderTranslations = i18n.reRenderTranslations.bind(i18n);
export var registerComponentUpdateHook = i18n.registerComponentUpdateHook.bind(i18n);
export var registerTranslateHook = i18n.registerTranslateHook.bind(i18n);
export var state = i18n.state;
export var stateObserver = i18n.stateObserver;
export var on = i18n.on.bind(i18n);
export var off = i18n.off.bind(i18n);
export var emit = i18n.emit.bind(i18n);
export var localize = localizeFactory(i18n);
export var useTranslate = translateHookFactory(i18n);

var _rtlFactory = rtlFactory(i18n),
    useRtl = _rtlFactory.useRtl,
    withRtl = _rtlFactory.withRtl;

export { useRtl, withRtl };